import styled, { css } from 'styled-components'

import { withBorder } from '@/theme/utils'

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['4']};
    padding-top: ${theme.space['24']};
  `,
)

export const Label = styled.label(
  ({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    color: ${theme.colors.black800};

    &[data-invalid='true'] {
      color: ${theme.colors.red500};
    }
  `,
)

export const Textarea = styled.textarea(
  ({ theme }) => css`
    width: 100%;
    height: 13.6rem;
    padding: ${withBorder(theme, 8)} ${withBorder(theme, 12)};
    border: ${theme.border.size['1']} solid ${theme.colors.gray500};
    border-radius: ${theme.border.radius['4']};
    resize: none;
    font-family: inherit;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2rem;
    color: ${theme.colors.primary800};
    background-color: ${theme.colors.gray100};
    outline: none;

    &[aria-invalid='true'] {
      border-color: ${theme.colors.red300};
      background-color: ${theme.colors.red100};
      color: ${theme.colors.red500};
    }

    &::placeholder {
      color: ${theme.colors.primary500};
    }

    &:focus {
      border-color: ${theme.colors.blue500};
    }
  `,
)

export const Counter = styled.span(
  ({ theme }) => css`
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 2rem;
    color: ${theme.colors.primary800};
    text-align: right;

    &[data-exceeded='true'] {
      color: ${theme.colors.red500};
    }
  `,
)
